import { render, staticRenderFns } from "./RequestStatusIndicator.vue?vue&type=template&id=2573f54a&scoped=true&"
import script from "./RequestStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./RequestStatusIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573f54a",
  null
  
)

export default component.exports